import React, { useMemo } from 'react';
import { Button, Form, Input, Space, Typography } from 'antd';
import { LeftOutlined, CloseOutlined } from '@ant-design/icons';
import { DEFAULT_CUSTOM_PROMPT_TEMPLATE } from './llmJudgeDefaults';

const { Text } = Typography;

const CustomCriteriaEditor = ({
  initialValues,
  onBack,
  onCancel,
  onOk,
}) => {
  const [form] = Form.useForm();

  const defaults = useMemo(() => ({
    name: '',
    promptTemplate: DEFAULT_CUSTOM_PROMPT_TEMPLATE,
  }), []);

  const init = { ...defaults, ...(initialValues || {}) };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Space>
          <Button type="text" icon={<LeftOutlined />} onClick={onBack} />
          <Text style={{ fontWeight: 600, fontSize: 16 }}>Custom</Text>
        </Space>
        <Button type="text" icon={<CloseOutlined />} onClick={onCancel} />
      </div>

      <Form
        form={form}
        layout="vertical"
        initialValues={init}
        style={{ marginTop: 16 }}
      >
        <Form.Item label="Name" name="name" rules={[{ required: true, message: 'Add a name for custom criteria' }]}>
          <Input placeholder="Add name for custom criteria" />
        </Form.Item>

        <Form.Item label="Evaluation Prompt Template" name="promptTemplate" rules={[{ required: true }]}>
          <Input.TextArea rows={10} />
        </Form.Item>

        <Text style={{ color: '#8c8c8c', fontSize: 12 }}>
          Use {'{full_text}'} and {'{summary}'} and {'{reference_summary}'} as placeholders for the source text and model summary and reference summary respectively.
          <div>[output should be between 1-100]</div>
        </Text>
      </Form>

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, marginTop: 16 }}>
        <Button onClick={onCancel}>Cancel</Button>
        <Button
          type="primary"
          onClick={async () => {
            const values = await form.validateFields();
            onOk(values);
          }}
        >
          Ok
        </Button>
      </div>
    </div>
  );
};

export default CustomCriteriaEditor;

